import styled from '@emotion/styled'

export const HalfWidthFlexContainer = styled.div(() => ({
  display: 'flex',
  gap: '3%',
  '> div': { width: '50%' }
}))
